<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="mt-5">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs
                                    variant="tabs"
                                    :fade="true"
                                    @update:activeTab="reloadTab"
                                    :active-tab="0"
                                >
                                    <!-- General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName: 'name',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template.name
                                                        .$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectLanguage
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'language_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .language_id.$model
                                                "
                                                :label="$t('language')"
                                                :placeholder="
                                                    $t('select_a_language')
                                                "
                                                :invalidFeedback="
                                                    $t('language_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'library_version',
                                                    })
                                                "
                                                :options="
                                                    this.forms.options
                                                        .library_options
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .library_version.$model
                                                "
                                                :label="$t('library_version')"
                                                :placeholder="
                                                    $t('library_version')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName: 'title',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template.title
                                                        .$model
                                                "
                                                :label="$t('meta_title')"
                                                :placeholder="
                                                    $t('enter_the_meta_title')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'meta_description',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .meta_description.$model
                                                "
                                                :label="$t('meta_description')"
                                                :placeholder="
                                                    $t(
                                                        'enter_the_meta_description'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'block_crawl',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .block_crawl.$model
                                                "
                                                :options="
                                                    traslateArrayObjects({
                                                        array: $options
                                                            .select_options
                                                            .yes_or_no,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :label="$t('block_trackers')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'action_redirect',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .action_redirect.$model
                                                "
                                                :options="
                                                    traslateArrayObjects({
                                                        array: $options
                                                            .select_options
                                                            .action_redirect,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :label="
                                                    $t(
                                                        'action_when_sending_the_data'
                                                    )
                                                "
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                v-if="
                                                    forms.template
                                                        .action_redirect == 1
                                                "
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'redirect_url',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .redirect_url.$model
                                                "
                                                :label="$t('redirect_url')"
                                                :placeholder="
                                                    $t('enter_the_redirect_url')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CTextarea
                                                v-if="
                                                    forms.template
                                                        .action_redirect == 2
                                                "
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'thank_you_message',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .thank_you_message
                                                        .$model
                                                "
                                                :label="$t('thank_you_message')"
                                                :placeholder="
                                                    $t(
                                                        'enter_the_thank_you_message'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                        </CCard>
                                    </CTab>
                                    <CTab :title="$t('Header Script')">
                                        <LCodeEditor
                                            :value.sync="
                                                forms.template
                                                    .head_section_scripts
                                            "
                                            :loading="storePageLoading"
                                            size="sm"
                                        />
                                    </CTab>
                                    <CTab :title="$t('Footer Script')">
                                        <LCodeEditor
                                            :value.sync="
                                                forms.template
                                                    .end_section_scripts
                                            "
                                            :placeholder="
                                                $t(
                                                    'enter_the_script_in_the_footer'
                                                )
                                            "
                                            :loading="storePageLoading"
                                            size="sm"
                                        />
                                    </CTab>
                                    <!-- Modal privacy -->
                                    <CTab :title="$t('modal_privacy')">
                                        <CCard bodyWrapper>
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'privacy_text_active',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .privacy_text_active
                                                        .$model
                                                "
                                                :options="
                                                    traslateArrayObjects({
                                                        array: $options
                                                            .select_options
                                                            .yes_or_no,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :label="
                                                    $t('enable_privacy_modal')
                                                "
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <ckeditor
                                                :editor="ckeditor.editor"
                                                v-model="ckeditor.editorData"
                                                @ready="onReady"
                                                :config="ckeditor.editorConfig"
                                                @input="onEditorInput"
                                            ></ckeditor>
                                        </CCard>
                                    </CTab>
                                    <!-- Form configuration -->
                                    <CTab :title="$t('form_configuration')">
                                        <CCard bodyWrapper>
                                            <h3>{{ $t("format_fields") }}</h3>
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'phone_field_active',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .phone_field_active
                                                        .$model
                                                "
                                                :options="
                                                    traslateArrayObjects({
                                                        array: $options
                                                            .select_options
                                                            .yes_or_no,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :label="
                                                    $t('validate_phone_format')
                                                "
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'phone_field',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .phone_field.$model
                                                "
                                                :label="$t('field_Name')"
                                                :placeholder="
                                                    $t('enter_the_fieldName')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        formName: 'template',
                                                        fieldName:
                                                            'phone_country',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.template
                                                        .phone_country.$model
                                                "
                                                :label="$t('countries')"
                                                :placeholder="
                                                    $t('enter_the_countries')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            >
                                                <template #description>
                                                    <span
                                                        class="input-group__description"
                                                        >it,es,fr....</span
                                                    >
                                                </template>
                                            </CInput>
                                        </CCard>
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <ButtonSave
                                    @click="submitForm($event, 'template')"
                                    :disabled="forms.template._loading"
                                />
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave.vue";

import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
} from "@coreui/icons";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapGetters } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import FontPlugin from "@ckeditor/ckeditor5-font/src/font";
import HeadingPlugin from "@ckeditor/ckeditor5-heading/src/heading";
import TablePlugin from "@ckeditor/ckeditor5-table/src/table";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import CodeBlockPlugin from "@ckeditor/ckeditor5-code-block/src/codeblock";
// import EasyImagePlugin from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import ImagePlugin from "@ckeditor/ckeditor5-image/src/image";
import AlignmentPlugin from "@ckeditor/ckeditor5-alignment/src/alignment";
// import ClipBoardPlugin from '@ckeditor/ckeditor5-clipboard/src/clipboard';
// import UploadPlugin from '@ckeditor/ckeditor5-upload/src/index';
import action_redirect from "~/assets/options/action_redirect.json";
import yes_or_no from "~/assets/options/yes_or_no.json";
import LCodeEditor from "~/components/LCodeEditor";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import formMixin from "~/mixins/form.js";

export default {
    name: "TemplateViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, formMixin],
    components: {
        SelectCountry,
        SelectLanguage,
        ckeditor: CKEditor.component,
        LCodeEditor,
        ButtonBack,
        ButtonSave,
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
    },
    select_options: {
        action_redirect,
        yes_or_no,
    },

    data() {
        return {
            forms: {
                template: {
                    id: null,
                    name: null,
                    language_id: null,
                    library_version: null,

                    title: null,
                    meta_description: null,
                    start_section_scripts: "",
                    head_section_scripts: "",
                    end_section_scripts: "",
                    pixel_after_send: null,
                    block_crawl: 1,
                    action_redirect: null,
                    redirect_url: null,
                    thank_you_message: null,
                    privacy_text_active: 0,
                    privacy_text: null,
                    // invalid_field_message:null, // To delete
                    phone_field_active: 0,
                    phone_field: null,
                    phone_country: null,
                    _loading: false,
                },
                options: {
                    library_options: [
                        "1.10.1",
                        "1.20.1",
                        { label: "2.0.0 (Discontinued)", value: "2.0.0" },
                        { label: "2.0.1 (Last stable)", value: "2.0.1" },
                        { label: "2.0.2 (In development)", value: "2.0.2" },
                    ],
                },
            },
            ckeditor: {
                editor: ClassicEditor,
                editorData: "",
                editorConfig: {
                    // The configuration of the editor.
                    plugins: [
                        Essentials,
                        BoldPlugin,
                        ItalicPlugin,
                        LinkPlugin,
                        ParagraphPlugin,
                        FontPlugin,
                        HeadingPlugin,
                        ListPlugin,
                        TablePlugin,
                        CodeBlockPlugin,
                        // EasyImagePlugin,
                        ImagePlugin,
                        // UploadPlugin,
                        AlignmentPlugin,
                        // ClipBoardPlugin,
                    ],
                    toolbar: {
                        items: [
                            "heading",
                            "|",
                            "fontfamily",
                            "fontsize",
                            "|",
                            "alignment",
                            "|",
                            "fontColor",
                            "fontBackgroundColor",
                            "|",
                            "bold",
                            "italic",
                            "strikethrough",
                            "underline",
                            "subscript",
                            "superscript",
                            "|",
                            "link",
                            "copy",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "bulletedList",
                            "numberedList",
                            "todoList",
                            "|",
                            "code",
                            "codeBlock",
                            "|",
                            "insertTable",
                            "|",
                            "uploadImage",
                            "blockQuote",
                            "|",
                            "undo",
                            "redo",
                        ],
                        shouldNotGroupWhenFull: true,
                    },
                },
            },
            next_page: "creativity",
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },

    validations: {
        forms: {
            template: {
                name: {
                    required,
                },
                language_id: {
                    required,
                },
                title: {},
                library_version: {},
                meta_description: {},
                start_section_scripts: {},
                head_section_scripts: {},
                end_section_scripts: {},
                pixel_after_send: {},
                block_crawl: {},
                action_redirect: {},
                redirect_url: {},
                thank_you_message: {},
                privacy_text_active: {},
                privacy_text: {},
                phone_field_active: {},
                phone_field: {},
                phone_country: {},
            },
        },
    },
    methods: {
        onEditorInput() {
            this.forms.template.privacy_text = this.ckeditor.editorData;
        },

        formParseData({ data }) {
            return this.normalizeObject(data);
        },

        async submitForm(e, formName) {
            if (e) e.preventDefault();
            if (this.uuid) {
                await this.sendForm({
                    formName,
                    url: `/templates.api/${this.uuid}/update`,
                    method: "PUT",
                });
            } else {
                await this.sendForm({
                    formName,
                    url: "/templates.api/create",
                });
            }
            this.$router.go(-1);
        },

        async updateData() {
            console.log(this.$route);
            await this.updateForm({
                formName: "template",
                url: "/templates.api/" + this.uuid,
            });
            this.ckeditor.editorData = this.forms.template.privacy_text
                ? this.forms.template.privacy_text
                : "";
            console.log("test", this.forms.template);
            this.updatePageLoading(false);
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui
                .getEditableElement()
                .parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );
        },

        reloadTab(index) {
            this.updatePageLoading(true);
            setTimeout(() => {
                this.updatePageLoading(false);
            }, 100);
        },
    },
    async mounted() {
        if (this.uuid) {
            await this.updateData();
        }
        this.updatePageLoading(false);
    },
};
</script>

<style scoped lang="scss">
</style>